module.exports = __webpack_public_path__ + "img/礼物奖励.1baedb45.png";